<template>
  <div class="container">
    <div class="log-box">
      <div class="box-header">
        <h1><span>智能打招呼运行中</span></h1>
      </div>
      <div class="box-section">
        <div class="jobInfo">
          <div class="job-title">招呼职位：</div>
          <div class="overNum">目标招呼：</div>
          <div class="lookNum">当前查看：</div>
          <div class="recruitNum">已打招呼：</div>
          <div class="overNum">胜任评分：</div>
        </div>
        <div class="comment">
          <div class="comment-title">评分分析：</div>
          <div class="comment-desc">
          </div>
        </div>
        <div class="log">
          <div class="log-title">运行日志：</div>
          <div class="log-desc">
          </div>
        </div>
        <div class="log-btn">
          <button class="save-btn" @click="stop">停止运行</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      value: '2025-07-08 22:21:09 - main - 开始运行'
    }
  },
  methods: {
    stop() {
      this.value += '\n2025-07-08 22:21:09 - main - 停止运行'
      this.$router.push('/zlgreet');
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.container {
  background-color: #111927;
  color: #fff;
  padding: 0 60px;
  user-select: none;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 10px;

  .log-box {
    padding: 10px;
    border-radius: 8px;
    background-color: #161e2e;

    .box-header {
      text-align: center;

      h1 {
        font-weight: 700;
        line-height: 1;
        margin-bottom: 10px;
        font-size: 16px;

        span {
          color: transparent;
          background-clip: text;
          --tw-gradient-to: #ec4899;
          --tw-gradient-from: #3b82f6;
          --tw-gradient-stops: #3b82f6, #ec4899;
          background-image: linear-gradient(to right, #3b82f6, #ec4899);
        }
      }
    }

    .box-section {
      .jobInfo {
        line-height: 1.5;
        border-radius: 6px;
        padding: 10px;
        font-size: 14px;
        background-color: #303a4a;
        margin-bottom: 6px;
      }

      .comment {
        border-radius: 6px;
        padding: 10px;
        font-size: 14px;
        background-color: #303a4a;
        margin-bottom: 6px;


        .comment-title {
          font-size: 15px;
          margin-bottom: 6px;
        }

        .comment-desc {
          height: 50px;
          line-height: 1.2;
          overflow-y: auto;
        }

        .comment-desc::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .comment-desc::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 4px;
        }

        .comment-desc::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 4px;
          border: 1px solid transparent;
        }

        .comment-desc::-webkit-scrollbar-thumb:hover {
          background-color: #aaa;
        }

      }

      .log {
        border-radius: 6px;
        padding: 10px;
        font-size: 14px;
        background-color: #303a4a;
        margin-bottom: 6px;


        .log-title {
          font-size: 15px;
          margin-bottom: 6px;
        }

        .log-desc {
          height: 238px;
          overflow-y: auto;
          line-height: 1.2;

          textarea {
            background-color: #303a4a;
            border: none;
            /* 移除所有边框 */
            outline: none;
            color: #fff;
            width: 100%;
            font-family: inherit;
            /* 继承父元素字体 */
            font-size: 12px;
            /* 继承父元素字号 */
            line-height: 1.3;
            /* 继承行高 */
            color: inherit;
            /* 继承文字颜色 */
            letter-spacing: inherit;
            /* 盒模型 */
            resize: none;
            /* 美化滚动条 - 适用于 WebKit 浏览器 (Chrome, Safari) */
            scrollbar-width: thin;
            /* Firefox */
            scrollbar-color: #ccc transparent;
            /* Firefox */
            height: 390px;

          }

        }

        .log-desc::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .log-desc::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 4px;
        }

        .log-desc::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 4px;
          border: 1px solid transparent;
        }

        .log-desc::-webkit-scrollbar-thumb:hover {
          background-color: #aaa;
        }

      }

      .log-btn {
        padding: 10px 20px;
        text-align: center;

        .save-btn {
          padding: 8px 20px;
          background-color: #675bf5;
          border: none;
          border-radius: 8px;
          color: #fff;
          cursor: pointer;
        }

        .save-btn:hover {
          background-color: #4c44d7;
        }
      }
    }
  }
}
</style>